<template>
    <div :class="{'product-selector': true, 'select-active': selectedProduct !== null }">
        <div v-for="product in reversedProducts"
             @click="selectedProduct === product.id ? selectProduct(null) : selectProduct(product.id)"
             :class="{'product-select': true, 'selected': selectedProduct === product.id}">
            <div class="product-description" v-html="product.description"></div>
            <div class="product-image"><img :src="product.img"></div>
            <div class="product-name"><span>{{ product.short_name }}</span></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"
    export default {
        name: 'ProductSelect',
        computed: mapGetters(['selectedProduct', 'reversedProducts']),
        methods: {
            selectProduct(product) {
                this.$store.dispatch(types.SET_PRODUCT, product)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ProductSelect.vue?1f2e4dab